import { black } from 'constants/colors';

const typography = {
  fontFamily: 'Helvetica Neue,'
  + 'RalewayRegular,'
  + '-apple-system,system-ui,BlinkMacSystemFont,'
  + '"Segoe UI",Raleway,"Helvetica Neue",Arial,sans-serif',
  color: black,
  htmlFontSize: 10,
  useNextVariants: true,
};

export default typography;



// WEBPACK FOOTER //
// ./src/components/OverrideTheme/config/typography.js